import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

async function main() {
    return bootstrapApplication(AppComponent, await appConfig()).catch((err) => console.error(err));
}
main();
